// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  /** X-App-Key para POST /api/logs/eventos — inyectar en CI; vacío desactiva envío local. */
  logsAppKey: 'G1s6h9K6Y2uL9lR2Vn3xjX5mK8QvB4tA7pN0cE3zW1Y=',
  appVersion: '1.0.0-qa',
  logsEnabled: true,
  /** POST /api/transportista/login + /datos-usuario; si false se usa login legacy .aspx */
  useGatewayAuth: true,
  host: 'https://dev-ecommerce.azurewebsites.net/',
  ResourceServer: 'https://polpaicotest.rankeadictos.cl/api/',
  ApiVersion: 'v1',
  ResourceLogin: 'https://www.polpaicoconexion.cl/clientes/ws/login_qa.aspx',
  ResourcePassWordRecovery: 'https://www.polpaicoconexion.cl/clientes/ws/recupera_clave.aspx',
  ResourceSaldoProductos: 'https://www.polpaicoconexion.cl/clientes/ws/contratos.aspx',
  ResourcePolpaico: 'https://www.polpaicoconexion.cl/clientes/ws/',
  ApiEcomer: 'https://back-ecommerce-dev.azurewebsites.net/api/v2/EcommerceOrder',
  ResourceDespachoSeguimiento: 'https://www.polpaicoconexion.cl/clientes/map.aspx?code=',
  ApiRunPdf: 'https://www.polpaicoconexion.cl/guias_cemento/guiaspd_setfirma.aspx',
  ApiNotificaciones: 'https://www.polpaicoconexion.cl/clientes/ws/mx_notif_v2.aspx',
  ApiERO: 'https://msh4klvo53.execute-api.us-east-1.amazonaws.com',
  daysEncuestaMixer: 7,
  moduloERO: 'checklist',
  /** Ruta pública del flujo de seguimiento anónimo (query: key, tkt_h, id1). */
  seguimientoAnonimoPublicPath: '/Seguimiento/3',
  /** Si false, el QR de cliente no se muestra hasta que el backend esté listo. */
  seguimientoAnonimoEnabled: true,
};
